import TimeRange from './TimeRange';

export default TimeRange;
